var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 79,
    viewBox: "0 0 77 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.0859 18.8799L19.57 6.58972",
    stroke: "black",
    strokeWidth: 4.36011,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.46875 20.7939L20.1688 26.672",
    stroke: "black",
    strokeWidth: 4.36012,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.2578 34.4639L3.70184 38.1772",
    stroke: "black",
    strokeWidth: 4.36012,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13872_57322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1749 16.6065L29.6486 25.6162C28.2775 25.6136 26.6913 26.6464 25.8655 28.2901C25.0092 29.9946 25.1274 31.8838 25.9479 32.9822L21.4521 41.931C21.0545 42.7224 21.1745 43.6976 21.7521 44.3689C22.3297 45.0403 23.2737 45.2859 24.0969 45.0132L28.1211 43.6804C32.5112 42.2263 37.2939 42.5706 41.4335 44.6503L41.9205 44.895L38.0058 52.6871C37.4552 53.7829 37.9402 55.0939 38.9751 55.6138L42.8712 57.5712C43.967 58.1217 45.2474 57.6976 45.7979 56.6018L49.7126 48.8097C51.9041 49.9107 54.465 49.0625 55.566 46.871L58.5021 41.0269C59.5725 38.8962 58.7549 36.2745 56.5634 35.1735L48.2842 31.0141C44.1446 28.9344 41.0134 25.3028 39.5594 20.9127L38.196 16.9494C37.9233 16.1262 37.1628 15.5154 36.2794 15.4528C35.396 15.3902 34.5419 15.876 34.1749 16.6065ZM35.7161 23.2514C37.6562 28.3431 41.4568 32.4634 46.3269 34.9101L46.8139 35.1548L43.8778 40.9989L43.3908 40.7542C38.5207 38.3076 32.9158 37.7789 27.6726 39.2618L35.7161 23.2514Z",
    fill: "black",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1749 16.6065L29.6486 25.6162C28.2775 25.6136 26.6913 26.6464 25.8655 28.2901C25.0092 29.9946 25.1274 31.8838 25.9479 32.9822L21.4521 41.931C21.0545 42.7224 21.1745 43.6976 21.7521 44.3689C22.3297 45.0403 23.2737 45.2859 24.0969 45.0132L28.1211 43.6804C32.5112 42.2263 37.2939 42.5706 41.4335 44.6503L41.9205 44.895L38.0058 52.6871C37.4552 53.7829 37.9402 55.0939 38.9751 55.6138L42.8712 57.5712C43.967 58.1217 45.2474 57.6976 45.7979 56.6018L49.7126 48.8097C51.9041 49.9107 54.465 49.0625 55.566 46.871L58.5021 41.0269C59.5725 38.8962 58.7549 36.2745 56.5634 35.1735L48.2842 31.0141C44.1446 28.9344 41.0134 25.3028 39.5594 20.9127L38.196 16.9494C37.9233 16.1262 37.1628 15.5154 36.2794 15.4528C35.396 15.3902 34.5419 15.876 34.1749 16.6065ZM35.7161 23.2514C37.6562 28.3431 41.4568 32.4634 46.3269 34.9101L46.8139 35.1548L43.8778 40.9989L43.3908 40.7542C38.5207 38.3076 32.9158 37.7789 27.6726 39.2618L35.7161 23.2514Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13872_57322",
    x: 3.77829,
    y: 0.913547,
    width: 72.6309,
    height: 77.2452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.90674
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.72023
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13872_57322"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13872_57322",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaller);
export default __webpack_public_path__ + "static/media/caller.a8b7d8d3b1ac98e7301db9cd6a217023.svg";
export { ForwardRef as ReactComponent };